// Tag for graphql format
const gql = String.raw;

const DefaultCommissionsTierFragment = gql`
	fragment FinanceDefaultCommissionsTierItem on FinanceDefaultCommissionsTierItem {
		from {
			...InputValue
		}
		to {
			...InputValue
		}
		commissions {
			...CommissionTiers
		}
	}
`;

const FinanceProductBonusesFragment = gql`
	fragment FinanceProductBonuses on FinanceProductBonuses {
		productName
		applyTotalGross
		minPVR {
			...InputValue
		}
		minPenetration {
			...InputValue
		}
		grossModifier {
			...InputValue
		}
		tiers {
			...CommissionTiers
		}
	}
`;

const FrontEndGrossProfitFragment = gql`
	fragment FrontEndGrossProfit on FrontEndGrossProfit {
		from {
			...InputValue
		}
		to {
			...InputValue
		}
		retail {
			...InputValue
		}
		lease {
			...InputValue
		}
		cash {
			...InputValue
		}
		miniDeal {
			...InputValue
		}
	}
`;

const FinanceDefaultCommissionContentFragment = gql`
	fragment FinanceDefaultCommissionContent on FinanceDefaultCommissionContent {
		tiers {
			...FinanceDefaultCommissionsTierItem
		}
		products {
			...FinanceProductBonuses
		}
		frontEndGrossProfit {
			...FrontEndGrossProfit
		}
	}
	${DefaultCommissionsTierFragment}
	${FinanceProductBonusesFragment}
	${FrontEndGrossProfitFragment}
`;

const DefaultCommissionsFragment = gql`
	fragment FinanceDefaultCommissions on FinanceDefaultCommissions {
		new {
			...FinanceDefaultCommissionContent
		}
		preOwned {
			...FinanceDefaultCommissionContent
		}
		globalGrossAndUnits
		isGuaranteedDraw
	}
	${FinanceDefaultCommissionContentFragment}
`;

const BumpTiersFragment = gql`
	fragment BumpTiers on FinanceBumpTiers {
		from {
			...InputValue
		}
		to {
			...InputValue
		}
		cash {
			...InputValue
		}
		lease {
			...InputValue
		}
	}
`;

const CashAndLeaseBumpFragment = gql`
	fragment CashAndLeaseBump on FinanceCashAndLeaseBump {
		metric
		bonus
		tiers {
			...BumpTiers
		}
	}
	${BumpTiersFragment}
`;

const ProductBonusesFragment = gql`
	fragment ProductBonuses on FinanceProductBonuses {
		productName
		useGrossProfit
		useDefaultRate
		boostPVR
		grossModifier {
			...InputValue
		}
		tiers {
			...CommissionTiers
		}
	}
`;

const CITBonusesFragment = gql`
	fragment CITBonuses on CITBonuses {
		tiers {
			...BonusesTiers
		}
		citType
		relativeToStore
	}
`;

const DepartmentOverrideNetIncomeFragment = gql`
	fragment DepartmentOverrideNetIncome on FinanceDepartmentOverrideNetIncome {
		chargeBacks
		commissionPayouts
		personalGrossProfit
		tiers {
			...BonusDefinition
		}
	}
`;

const PVRQualifierFragment = gql`
	fragment PVRQualifier on FinancePVRQualifierTier {
		from {
			...InputValue
		}
		to {
			...InputValue
		}
		adjustment {
			...InputValue
		}
	}
`;

const MaxPayoutFragment = gql`
	fragment MaxPayout on MaxPayout {
		frontend {
			...InputValue
		}
		backend {
			...InputValue
		}
		afterChargebacks
	}
`;

export {
	CashAndLeaseBumpFragment,
	CITBonusesFragment,
	DefaultCommissionsFragment,
	DepartmentOverrideNetIncomeFragment,
	MaxPayoutFragment,
	ProductBonusesFragment,
	PVRQualifierFragment,
};
